export enum PackageCode {
  CONF = 'CON',
  CONF_PLUS = 'CON+',
  PARISIENNE = 'PAR2',
  SOLIDAIRE = 'SOL2',
  TOURQUENNOISE = 'TOU2',
  LILLOISE = 'LIL2',
  GRENOBLOISE = 'GRE',
  CRISTOLIENNE = 'CRE',
  ETUDIANTE = 'ETU',
  MARSEILLAISE = 'MAR',
  BAILLEURS_SOCIAUX = 'BSOL'
}
